import React, {Component} from 'react';
import './SearchBooks.css';
import {Grid} from 'react-bootstrap';
import Book from './Book';





export default class SearchBooks extends Component {


    render() {


        if (this.props.data.length === 0) {

            return (
                <div>

                </div>

            )

        }


        return (
            <Grid>


                {this.props.data.map((book, index) => (
                    <Book typee={2} key={book.id} {...book}/>
                ))}


            </Grid>

        )
    }

}




// WEBPACK FOOTER //
// ./src/components/SearchBooks.js